export default __webpack_public_path__ + "static/media/yourMoney.aad660cc.svg";